import { render, staticRenderFns } from "./TaskListDetailsDialog.vue?vue&type=template&id=2d972555"
import script from "./TaskListDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TaskListDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports